import React, { useContext } from 'react';
import { UserContext, UserStatus } from './UserContext';

type Props = {
  children: React.ReactNode;
}

export const NonUserTemplate: React.FC<Props> = ({ children }) => {
  const userStatus = useContext<UserStatus>(UserContext);
  return (<>
    {!userStatus.user && children}
  </>);
}
